export const SLIDER_ARROW_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <g filter="url(#filter0_d_13813_1190)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6 2C5.5 2 5 2.33333 5 3C5 3.66667 5.33333 4 6 4L14 10L6 16C5.33333 16 5 16.3333 5 17C5 17.6667 5.5 18 6 18L16 10L6 2Z" fill="white"/>
  </g>
  <defs>
    <filter id="filter0_d_13813_1190" x="-3" y="-0.000244141" width="24" height="24" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13813_1190"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13813_1190" result="shape"/>
    </filter>
  </defs>
</svg>
`;
